import {
  ShoppingBag,
  Wrench,
  Cog,
  Lightbulb,
  Building2,
  Settings,
  Route,
  Database,
  Shield,
  TrendingUp,
  TrendingDown,
  BarChart3,
  CreditCard,
  Users,
  Layers,
  ScrollText,
  Package,
  Cable,
  CircleDot,
  LayoutDashboard,
  House,
  Files,
  MessageSquare,
  Bell,
  Zap,
  ClipboardList,
  CheckSquare,
  Image,
  FolderTree,
  Castle,
  Network,
  HandCoins,
  TrafficCone,
  DollarSign,
  ChartCandlestick,
  FileText,
  Funnel,
  Brain,
  Sofa,
  EthernetPort,
  Group,
  ShieldUser,
  UserLock,
  ScanEye,
  University,
  PencilRuler,
  SquareKanban,
  Archive,
  Box,
  HardHat,
  Clock,
  GanttChart,
  ArrowLeftRight,
  ShoppingCart,
  Tag,
  Ruler,
  Calendar,
  Drill,
  Wallet,
  Landmark,
  ListFilter,
  ClipboardCheck,
  Tags,
  Gift,
  Percent,
  Key,
  Webhook,
  BookOpen,
  Truck,
  type LucideIcon
} from "lucide-react";

/**
 * Shape of a navigation item. The `navigationItems` literal is heterogeneous —
 * some items are leaves (with `view`), some are groups (with `children`), and
 * some helpers (e.g. `getNavigationByView`) augment the item with a `parent`
 * reference. Every field except `id`, `label` and `icon` is optional so the
 * interface can describe both leaves and groups under a single type.
 */
export interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  view?: string;
  subview?: string;
  groupView?: string;
  category?: string;
  description?: string;
  permission?: string;
  permissions?: readonly string[];
  children?: readonly NavItem[];
  parent?: NavItem;
}

/**
 * Entry produced by `getBreadcrumbs`. Leaves carry `view` and `current`;
 * intermediate group entries may omit `view` and set `parent: true` instead.
 */
export interface Breadcrumb {
  label: string;
  view?: string;
  parent?: boolean;
  current?: boolean;
}

export const navigationItems: NavItem[] = [
  {
    id: 'calendario',
    label: 'Calendário',
    icon: Calendar,
    category: 'main',
    view: 'atividade-consultor',
    description: 'Agenda integrada de atividades (reunioes, ligacoes, visitas)',
    permission: 'ATIVIDADE'
  },
  {
    id: 'comercial-group',
    label: 'Comercial',
    icon: HandCoins,
    category: 'main',
    groupView: 'oportunidades-ativas-v2',
    children: [
      {
        id: 'oportunidades-ativas',
        label: 'Oportunidades ativas',
        icon: Funnel,
        view: 'oportunidades-ativas-v2',
        description: 'Pipeline de oportunidades em andamento',
        permission: 'OPORTUNIDADE'
      },
      {
        id: 'oportunidades-encerradas',
        label: 'Oportunidades encerradas',
        icon: Archive,
        view: 'oportunidades-encerradas-v2',
        description: 'Oportunidades finalizadas (ganhas ou perdidas)',
        permission: 'OPORTUNIDADE'
      },
      {
        id: 'orcamento-escopo',
        label: 'Orçamento por escopo',
        icon: Lightbulb,
        view: 'orcamento-escopo',
        description: 'Orçamento por escopo de cargas',
        permission: 'COMERCIAL_TOOLS'
      },
      {
        id: 'vendas',
        label: 'Vendas',
        icon: ShoppingBag,
        view: 'vendas',
        description: 'Listagem de vendas (propostas aceitas)',
        permission: 'VENDAS'
      },
      {
        id: 'proposta-resultado',
        label: 'Resultado',
        icon: BarChart3,
        view: 'proposta-resultado',
        description: 'Fila de propostas aceitas para a diretoria',
        permission: 'PROPOSTA_RESULTADO'
      },
      {
        id: 'comissao',
        label: 'Comissão',
        icon: HandCoins,
        view: 'comissao',
        description: 'Acompanhe sua comissão mensal',
        permission: 'COMISSAO'
      },
      {
        id: 'comissao-parametro',
        label: 'Parâmetros de Comissão',
        icon: Percent,
        view: 'comissao-parametro',
        description: 'Configurar faixas de volume e margem para comissões',
        permission: 'COMISSAO_PARAMETRO'
      },
      {
        id: 'comissao-bonus',
        label: 'Bônus de Comissão',
        icon: Gift,
        view: 'comissao-bonus',
        description: 'Multiplicadores ou valores fixos por produto, subcategoria ou marca',
        permission: 'COMISSAO_PARAMETRO'
      },
      {
        id: 'proposta-grupo-imagem',
        label: 'Imagens de Proposta',
        icon: Image,
        view: 'proposta-grupo-imagem-manager',
        description: 'Gerenciar imagens de grupos de proposta',
        permission: 'PROPOSTA_IMAGEM'
      },
      {
        id: 'proposta-parametro',
        label: 'Parâmetros de Proposta',
        icon: Settings,
        view: 'proposta-parametro',
        description: 'Configurar valores padrão para novas propostas',
        permission: 'PROPOSTA_PARAMETRO'
      },
      {
        id: 'oportunidade-status',
        label: 'Status de Oportunidade',
        icon: ChartCandlestick,
        view: 'oportunidade-status',
        description: 'Configurar status do pipeline de oportunidades',
        permission: 'OPORTUNIDADE_STATUS'
      },
    ]
  },
  {
    id: 'obras',
    label: 'Obras',
    icon: TrafficCone,
    view: 'obras',
    category: 'main',
    groupView: 'obras',
    description: 'Controle e acompanhamento de projetos',
    permission: 'OBRA',
    children: [
      {
        id: 'obras-jornadas',
        label: 'Jornada',
        icon: ScrollText,
        view: 'obras-jornadas',
        description: 'Jornada completa do cliente - do CRM à entrega',
        permission: 'OBRA_JORNADA'
      },
      {
        id: 'obras-areas',
        label: 'Áreas',
        icon: University,
        view: 'obras-areas',
        description: 'Áreas das obras',
        permission: 'OBRA_AREA'
      },
      {
        id: 'obras-ambientes',
        label: 'Ambientes',
        icon: House,
        view: 'obras-ambientes',
        description: 'Ambientes das obras',
        permission: 'OBRA_AMBIENTE'
      },
      {
        id: 'obras-pontos',
        label: 'Pontos',
        icon: Lightbulb,
        view: 'obras-pontos',
        description: 'Pontos de iluminação das obras',
        permission: 'OBRA_PONTO'
      },
      {
        id: 'obras-produtos',
        label: 'Produtos',
        icon: Package,
        view: 'obras-produtos',
        description: 'Produtos utilizados nas obras',
        permission: 'OBRA_PRODUTO'
      },
      {
        id: 'obras-cabos',
        label: 'Cabos',
        icon: Cable,
        view: 'obras-cabos',
        description: 'Cabos utilizados nas obras',
        permission: 'OBRA_CABO'
      },
      {
        id: 'obras-tubos',
        label: 'Tubos',
        icon: CircleDot,
        view: 'obras-tubos',
        description: 'Tubos utilizados nas obras',
        permission: 'OBRA_TUBO'
      },
      {
        id: 'obras-pessoas',
        label: 'Envolvidos',
        icon: Users,
        view: 'obras-pessoas',
        description: 'Pessoas envolvidas nas obras',
        permission: 'OBRA_ENVOLVIDO'
      },
      {
        id: 'obras-servicos',
        label: 'Serviços',
        icon: Wrench,
        view: 'obras-servicos',
        description: 'Serviços das obras',
        permission: 'OBRA_SERVICO'
      },
      {
        id: 'obras-vistorias',
        label: 'Vistorias',
        icon: ClipboardCheck,
        view: 'obras-vistorias',
        description: 'Vistorias das obras',
        permission: 'OBRA_SERVICO'
      },
      {
        id: 'obras-andamentos',
        label: 'Andamentos',
        icon: Clock,
        view: 'obras-andamentos',
        description: 'Cronograma e andamento por etapa das obras',
        permission: 'OBRA_ANDAMENTO'
      },
      {
        id: 'obras-cronograma',
        label: 'Cronograma (Gantt)',
        icon: GanttChart,
        view: 'obras-cronograma',
        description: 'Visualização do cronograma em gráfico de Gantt',
        permission: 'OBRA_CRONOGRAMA'
      }
    ]
  },
  {
    id: 'suprimentos-group',
    label: 'Suprimentos',
    icon: Package,
    category: 'main',
    description: 'Gestão de estoque, requisições e compras',
    children: [
      {
        id: 'suprimentos-requisicoes-ativas',
        label: 'Requisições Ativas',
        icon: ClipboardList,
        view: 'suprimentos-requisicoes-ativas',
        description: 'Requisições de material em andamento',
        permission: 'REQUISICAO'
      },
      {
        id: 'suprimentos-requisicoes-encerradas',
        label: 'Requisições Encerradas',
        icon: ClipboardList,
        view: 'suprimentos-requisicoes-encerradas',
        description: 'Requisições finalizadas ou canceladas',
        permission: 'REQUISICAO'
      },
      {
        id: 'suprimentos-movimentacao',
        label: 'Movimentação de Estoque',
        icon: ArrowLeftRight,
        view: 'suprimentos-movimentacao',
        description: 'Entradas e saídas de produtos',
        permission: 'MOVIMENTACAO_ESTOQUE'
      },
      {
        id: 'suprimentos-balanco',
        label: 'Balanço de Estoque',
        icon: ClipboardCheck,
        view: 'suprimentos-balanco',
        description: 'Contagem física e registro de seriais',
        permission: 'ESTOQUE'
      },
      {
        id: 'suprimentos-cat',
        label: 'CAT',
        icon: Wrench,
        view: 'suprimentos-cat',
        description: 'Chamados de assistência técnica',
        permission: 'CAT'
      },
      {
        id: 'suprimentos-triagem',
        label: 'Triagem de Compra',
        icon: ListFilter,
        view: 'suprimentos-triagem',
        description: 'Triagem de itens para compra e geração de OCs',
        permission: 'ORDEM_COMPRA'
      },
      {
        id: 'suprimentos-ordem-compra',
        label: 'Ordem de Compra',
        icon: ShoppingCart,
        view: 'suprimentos-ordem-compra',
        description: 'Gestão de ordens de compra',
        permission: 'ORDEM_COMPRA'
      },
      {
        id: 'suprimentos-config',
        label: 'Configurações',
        icon: Settings,
        description: 'Configurações do módulo de suprimentos',
        children: [
          {
            id: 'suprimentos-ordem-compra-status',
            label: 'Status de OC',
            icon: ChartCandlestick,
            view: 'suprimentos-ordem-compra-status',
            description: 'Configurar status das ordens de compra',
            permission: 'ORDEM_COMPRA_STATUS'
          },
          {
            id: 'suprimentos-marca',
            label: 'Marcas',
            icon: Tag,
            view: 'suprimentos-marca',
            description: 'Cadastro de marcas',
            permission: 'MARCA'
          },
          {
            id: 'suprimentos-produto-categoria',
            label: 'Categorias de Produto',
            icon: FolderTree,
            view: 'suprimentos-produto-categoria',
            description: 'Categorias de produtos',
            permission: 'PRODUTO_CATEGORIA'
          },
          {
            id: 'suprimentos-produto-subcategoria',
            label: 'SubCategorias de Produto',
            icon: FolderTree,
            view: 'suprimentos-produto-subcategoria',
            description: 'SubCategorias de produtos',
            permission: 'PRODUTO_SUBCATEGORIA'
          },
          {
            id: 'suprimentos-produto-tipo',
            label: 'Tipos de Produto',
            icon: Layers,
            view: 'suprimentos-produto-tipo',
            description: 'Tipos de produtos',
            permission: 'PRODUTO_TIPO'
          },
          {
            id: 'suprimentos-classificacao',
            label: 'Classificação em Massa',
            icon: Tags,
            view: 'suprimentos-classificacao',
            description: 'Classificar produtos por tipo em massa',
            permission: 'PRODUTO'
          },
          {
            id: 'suprimentos-unidade-medida',
            label: 'Unidades de Medida',
            icon: Ruler,
            view: 'suprimentos-unidade-medida',
            description: 'Unidades de medida',
            permission: 'PRODUTO_UNIDADE'
          },
          {
            id: 'suprimentos-margem-tipo',
            label: 'Tipos de Margem',
            icon: BarChart3,
            view: 'suprimentos-margem-tipo',
            description: 'Tipos de margem de produto',
            permission: 'PRODUTO_MARGEM'
          }
        ]
      }
    ]
  },
  {
    id: 'os-group',
    label: 'Ordens de Serviço',
    icon: Drill,
    category: 'main',
    groupView: 'os-agenda',
    description: 'Gestão de ordens de serviço',
    children: [
      {
        id: 'os-ativas',
        label: 'Todas as OS',
        icon: ClipboardList,
        view: 'os-ativas',
        description: 'OS em espera e agendadas',
        permission: 'OS'
      },
      {
        id: 'os-agenda',
        label: 'Agenda',
        icon: Calendar,
        view: 'os-agenda',
        description: 'Visualização em calendário das OS agendadas',
        permission: 'OS'
      }
    ]
  },
  {
    id: 'projetos-group',
    label: 'Projetos',
    icon: PencilRuler,
    category: 'main',
    groupView: 'projetos-ativos',
    description: 'Gestão de projetos técnicos',
    children: [
      {
        id: 'projetos-ativos',
        label: 'Projetos Ativos',
        icon: SquareKanban,
        view: 'projetos-ativos',
        description: 'Kanban de projetos em andamento',
        permission: 'PROJETO'
      },
      {
        id: 'projetos-encerrados',
        label: 'Projetos Encerrados',
        icon: Archive,
        view: 'projetos-encerrados',
        description: 'Listagem de projetos finalizados',
        permission: 'PROJETO'
      },
      {
        id: 'projeto-status',
        label: 'Status de Projetos',
        icon: ChartCandlestick,
        view: 'projeto-status',
        description: 'Configuração de status de projetos',
        permission: 'PROJETO_STATUS'
      }
    ]
  },
  {
    id: 'tarefas',
    label: 'Tarefas',
    icon: CheckSquare,
    view: 'tarefas',
    category: 'main',
    description: 'Gestão de tarefas e atividades',
    permission: 'TAREFA'
  },
  {
    id: 'ferramentas',
    label: 'Ferramentas',
    icon: Brain,
    category: 'tools',
    children: [
      {
        id: 'config',
        label: 'Regras de Cálculo',
        icon: Settings,
        view: 'config',
        description: 'Regras, parâmetros e configurações do sistema',
        permission: 'REGRAS_CALCULO'
      },
      {
        id: 'cable-routing',
        label: 'Roteamento de Cabos',
        icon: Route,
        view: 'cable-routing',
        description: 'Cálculo de trajetos e dimensionamento',
        permission: 'CABLE_ROUTING'
      },
      {
        id: 'google-chat-manager',
        label: 'Gerenciar Google Chat',
        icon: MessageSquare,
        view: 'google-chat-manager',
        description: 'Adicionar usuários aos espaços do Google Chat',
        permission: 'GOOGLECHAT_ADMIN'
      },
      {
        id: 'sync-os-fotos',
        label: '🔧 Sync Fotos OS',
        icon: Image,
        view: 'sync-os-fotos',
        description: 'Sincronizar fotos órfãs de OS com o banco de dados',
        permission: 'ADMIN_TOOLS'
      },
      {
        id: 'conexoes-group',
        label: 'Conexões',
        icon: Cable,
        description: 'Gestão de conexões entre equipamentos',
        children: [
          {
            id: 'templates-porta',
            label: 'Templates de Porta',
            icon: Package,
            view: 'templates-porta',
            description: 'Gerenciar templates de portas de produtos',
            permission: 'TELA_TEMPLATES_PORTA'
          },
          {
            id: 'dashboard-conexoes',
            label: 'Dashboard de Conexões',
            icon: LayoutDashboard,
            view: 'dashboard-conexoes',
            description: 'Visualizar e gerenciar conexões em obras',
            permission: 'TELA_DASHBOARD_CONEXOES'
          },
          {
            id: 'tipos-cabo',
            label: 'Tipos de Cabo',
            icon: Cable,
            view: 'tipos-cabo',
            description: 'Catálogo de tipos de cabo',
            permission: 'TELA_TIPOS_CABO'
          },
          {
            id: 'config-portas',
            label: 'Configurações de Porta',
            icon: Settings,
            view: 'config-portas',
            description: 'Configurar categorias, tipos e compatibilidade de portas',
            permission: 'TELA_CONFIG_PORTAS'
          }
        ]
      }
    ]
  },
  {
    id: 'financeiro',
    label: 'Financeiro',
    icon: DollarSign,
    category: 'main',
    description: 'Gestão financeira e controle de contas',
    // Grupo visível se tiver qualquer permissão VIEW do módulo financeiro
    permissions: [
      'FINANCEIRO_LANCAMENTO',
      'FINANCEIRO_BANCO',
      'FINANCEIRO_CONTA',
      'FINANCEIRO_CENTRO_CUSTO',
      'FINANCEIRO_CATEGORIA_CONTABIL',
      'FORMA_PAGAMENTO'
    ],
    children: [
      {
        id: 'contas-receber',
        label: 'Contas a Receber',
        icon: TrendingUp,
        view: 'contas-receber',
        description: 'Valores a receber de clientes',
        permission: 'FINANCEIRO_LANCAMENTO'
      },
      {
        id: 'contas-pagar',
        label: 'Contas a Pagar',
        icon: TrendingDown,
        view: 'contas-pagar',
        description: 'Valores a pagar para fornecedores',
        permission: 'FINANCEIRO_LANCAMENTO'
      },
      {
        id: 'movimentos',
        label: 'Movimentos',
        icon: BarChart3,
        view: 'movimentos',
        description: 'Movimentações bancárias e fluxo de caixa',
        permission: 'FINANCEIRO_LANCAMENTO'
      },
      {
        id: 'caixa',
        label: 'Caixa',
        icon: Landmark,
        view: 'caixa',
        description: 'Saldo, fluxo e conciliação por conta',
        permission: 'FINANCEIRO_LANCAMENTO'
      },
      {
        id: 'bancos',
        label: 'Bancos',
        icon: Building2,
        view: 'bancos',
        description: 'Cadastro de bancos',
        permission: 'FINANCEIRO_BANCO'
      },
      {
        id: 'contas-bancarias',
        label: 'Contas Bancárias',
        icon: CreditCard,
        view: 'contas-bancarias',
        description: 'Contas bancárias por banco',
        permission: 'FINANCEIRO_CONTA'
      },
      {
        id: 'centros-custo',
        label: 'Centros de Custo',
        icon: FolderTree,
        view: 'centros-custo',
        description: 'Organização hierárquica para rateio',
        permission: 'FINANCEIRO_CENTRO_CUSTO'
      },
      {
        id: 'categorias-contabeis',
        label: 'Plano de Contas',
        icon: Layers,
        view: 'categorias-contabeis',
        description: 'Classificação contábil de receitas e despesas',
        permission: 'FINANCEIRO_CATEGORIA_CONTABIL'
      },
      {
        id: 'formas-pagamento',
        label: 'Formas de Pagamento',
        icon: Wallet,
        view: 'formas-pagamento',
        description: 'Pix, Boleto, Cartão e configurações de parcelas',
        permission: 'FORMA_PAGAMENTO'
      }
    ]
  },
  {
    id: 'planejamento',
    label: 'Planejamento',
    icon: ClipboardList,
    category: 'main',
    children: [
      {
        id: 'painel-cargas',
        label: 'Painel de Cargas',
        icon: Lightbulb,
        view: 'painel-cargas',
        description: 'Dimensionamento técnico e cálculos',
        permission: 'PLANEJAMENTO'
      },
      {
        id: 'planejamento-automatico',
        label: 'Planejamento Automático',
        icon: Zap,
        view: 'auto-services',
        description: 'Geração automática de produtos, serviços e andamentos',
        permission: 'PLANEJAMENTO'
      },
      {
        id: 'produtos-a-comprar',
        label: 'Produtos à Comprar',
        icon: ShoppingCart,
        view: 'produtos-a-comprar',
        description: 'Custo do que ainda falta comprar, por obra',
        permission: 'PRODUTO_A_COMPRAR'
      }
    ]
  },
  {
    id: 'cadastro',
    label: 'Cadastro',
    icon: Database,
    category: 'admin',
    children: [
      {
        id: 'produtos-config',
        label: 'Produtos',
        icon: Box,
        view: 'produtos',
        description: 'Cadastro de produtos',
        permission: 'PRODUTO'
      },
      {
        id: 'empreendimentos-config',
        label: 'Empreendimentos',
        icon: Building2,
        view: 'empreendimentos',
        description: 'Cadastro de empreendimentos',
        permission: 'EMPREENDIMENTO'
      },
      {
        id: 'pessoas-config',
        label: 'Pessoas',
        icon: Users,
        view: 'pessoas',
        description: 'Cadastro e gestão de pessoas',
        permission: 'PESSOA'
      },
      {
        id: 'fornecedores-config',
        label: 'Fornecedores',
        icon: Truck,
        view: 'fornecedores',
        description: 'Cadastro de fornecedores',
        permission: 'FORNECEDOR'
      },
      {
        id: 'departamentos-config',
        label: 'Departamentos',
        icon: Network,
        view: 'departamentos',
        description: 'Estrutura organizacional',
        permission: 'DEPARTAMENTO'
      },
      {
        id: 'cidades-config',
        label: 'Cidades',
        icon: Building2,
        view: 'cidades',
        description: 'Cadastro de cidades',
        permission: 'CIDADE'
      },
      {
        id: 'estados-config',
        label: 'Estados',
        icon: Castle,
        view: 'estados',
        description: 'Cadastro de estados',
        permission: 'ESTADO'
      }
    ]
  },
  {
    id: 'configuracoes',
    label: 'Configurações',
    icon: Cog,
    category: 'admin',
    children: [
      // Tipos e Configurações
      {
        id: 'tipos-ambiente-config',
        label: 'Tipos de Ambiente',
        icon: Sofa,
        view: 'tipos-ambiente',
        description: 'Configuração de tipos de ambiente',
        permission: 'AMBIENTE_TIPO'
      },
      {
        id: 'tipos-ponto-config',
        label: 'Tipos de Ponto',
        icon: EthernetPort,
        view: 'tipos-ponto',
        description: 'Configuração de tipos de ponto',
        permission: 'PONTO_TIPO'
      },
      {
        id: 'grupos-tipo-ponto-config',
        label: 'Grupos de Tipos de Ponto',
        icon: Group,
        view: 'grupos-tipo-ponto',
        description: 'Grupos de tipos de ponto',
        permission: 'PONTO_TIPO_GRUPO'
      },
      {
        id: 'tipos-servico-config',
        label: 'Tipos de Serviço',
        icon: Wrench,
        view: 'tipos-servico',
        description: 'Configuração de tipos de serviço',
        permission: 'SERVICO_TIPO'
      },
      {
        id: 'tipos-vistoria-config',
        label: 'Tipos de Vistoria',
        icon: ClipboardCheck,
        view: 'tipos-vistoria',
        description: 'Configuração de tipos de vistoria',
        permission: 'SERVICO_TIPO'
      },
      {
        id: 'profissional-tipo-config',
        label: 'Tipos de Profissional',
        icon: HardHat,
        view: 'profissional-tipo',
        description: 'Tipos de profissionais executores de serviços',
        permission: 'PROFISSIONAL_TIPO'
      },
      {
        id: 'atraso-motivo-config',
        label: 'Motivos de Atraso',
        icon: Clock,
        view: 'atraso-motivo',
        description: 'Catálogo de motivos de atraso para cronograma',
        permission: 'ATRASO_MOTIVO'
      },
      {
        id: 'atividade-config-tipos',
        label: 'Tipos de Atividade',
        icon: Calendar,
        view: 'atividade-config-tipos',
        description: 'Gerenciar tipos de atividade',
        permission: 'ATIVIDADE_TIPO'
      },
      {
        id: 'atividade-config-areas',
        label: 'Áreas de Atividade',
        icon: Calendar,
        view: 'atividade-config-areas',
        description: 'Gerenciar áreas e salas para reserva',
        permission: 'ATIVIDADE_TIPO'
      },
      {
        id: 'obra-etapa-config',
        label: 'Etapas da Obra',
        icon: Layers,
        view: 'obra-etapa',
        description: 'Administração das Etapas de Obra e seus parâmetros',
        permission: 'OBRA_ETAPA'
      },
      {
        id: 'obra-produto-status-config',
        label: 'Status do Produto da Obra',
        icon: Package,
        view: 'obra-produto-status',
        description: 'Status dos produtos utilizados nas obras',
        permission: 'OBRA_PRODUTO_STATUS'
      },

      // Templates
      {
        id: 'pdf-templates',
        label: 'Templates de PDF',
        icon: Files,
        view: 'pdf-template-manager',
        description: 'Gerenciar templates de PDF para propostas',
        permission: 'ADMIN_TOOLS'
      },
      {
        id: 'pdf-layout-builder',
        label: 'Editor de PDF (Novo)',
        icon: FileText,
        view: 'pdf-layout-builder',
        description: 'Editor visual de templates de PDF com drag-and-drop',
        permission: 'ADMIN_TOOLS'
      },

      // Categorias de Arquivo
      {
        id: 'file-categorias',
        label: 'Categorias de Arquivo',
        icon: FolderTree,
        view: 'file-categorias',
        description: 'Gerenciar categorias para classificação de arquivos',
        permission: 'ADMIN_TOOLS'
      },

      // Regras de Transição
      {
        id: 'transition-rules-config',
        label: 'Regras de Transição',
        icon: ArrowLeftRight,
        view: 'transition-rules',
        description: 'Gerenciar regras de transição de status em pipelines',
        permission: 'ADMIN_TOOLS'
      },

      // Notificações
      {
        id: 'notificacoes-config',
        label: 'Notificações',
        icon: Bell,
        view: 'notificacoes',
        description: 'Configuração de notificações e alertas do sistema',
        permission: 'NOTIFICACOES'
      },

      // API pública
      {
        id: 'api-keys-config',
        label: 'API Keys',
        icon: Key,
        view: 'api-keys',
        description: 'Gerar e gerenciar chaves da API pública',
        permission: 'API_KEY'
      },
      {
        id: 'api-docs-config',
        label: 'Documentação da API',
        icon: BookOpen,
        view: 'api-docs',
        description: 'Referência interativa OpenAPI 3.1 (Scalar)',
        permission: 'API_KEY'
      },
      {
        id: 'webhooks-config',
        label: 'Webhooks',
        icon: Webhook,
        view: 'webhooks',
        description: 'Receba notificações HTTP em tempo real para mudanças em pessoas, obras, atividades e OS',
        permission: 'WEBHOOK'
      }
    ]
  },
  {
    id: 'seguranca',
    label: 'Segurança',
    icon: Shield,
    category: 'admin',
    children: [
      {
        id: 'usuarios',
        label: 'Usuários',
        icon: ShieldUser,
        view: 'equipe',
        description: 'Gestão de usuários do sistema',
        permission: 'USUARIO'
      },
      {
        id: 'perfis',
        label: 'Perfis de Acesso',
        icon: UserLock,
        view: 'perfis',
        description: 'Gestão de perfis de acesso e permissões do tenant',
        permission: 'PERFIL'
      },
      {
        id: 'modulos-config',
        label: 'Módulos do Sistema',
        icon: Layers,
        view: 'modulos',
        description: 'Gestão de módulos do sistema de permissões',
        permission: 'MODULO'
      },
      {
        id: 'auditoria-logs',
        label: 'Logs de Auditoria',
        icon: ScanEye,
        view: 'auditoria-logs',
        description: 'Histórico de alterações em permissões',
        permission: 'AUDITORIA'
      }
    ]
  }
];

export const getNavigationByView = (view: string): NavItem | null => {
  for (const item of navigationItems) {
    if (item.view === view) return item;
    if (item.children) {
      const child = item.children.find(child => child.view === view);
      if (child) return { ...child, parent: item };
    }
  }
  return null;
};

export const getBreadcrumbs = (currentView: string): Breadcrumb[] => {
  const nav = getNavigationByView(currentView);
  if (!nav) return [{ label: 'Home', view: 'home' }];

  const breadcrumbs: Breadcrumb[] = [{ label: 'Home', view: 'home' }];

  if (nav.parent) {
    breadcrumbs.push({ label: nav.parent.label, parent: true });
  }

  breadcrumbs.push({ label: nav.label, view: nav.view, current: true });

  return breadcrumbs;
};